import { Button, Modal } from 'semantic-ui-react';
import './CreateProjectModal.scss';
import Project from '../../../../structures/project';
import CreateProjectWizard from '../CreateProjectWizard/CreateProjectWizard';

interface CreateProjectModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onSave: (project: Project) => void;
}

function CreateProjectModal({open, setOpen, onSave}:CreateProjectModalProps) {
    return <Modal
        open={open}
        onClose={() => setOpen(false)}
        className='create-project-modal'
        centered={false}
        size='large'
        closeIcon
        closeOnDimmerClick={false}
    >
        <Modal.Header>Новый проект</Modal.Header>
        <Modal.Content>
            <CreateProjectWizard onFinish={onSave} />
        </Modal.Content>
        <Modal.Actions>
            <Button basic onClick={() => setOpen(false)}>Отмена</Button>
        </Modal.Actions>
    </Modal>
};

export default CreateProjectModal;